import t from"react";import{MdIcon as r}from"./MdIcon.js";import{mdiMagnify as e}from"@mdi/js";const o=({id:o="search",title:i="Search",...m})=>t.createElement(r,{id:o,title:i,path:e,...m});export{o as SearchIcon};
